<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import lodash from 'lodash';
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowNumErrorsPerTech',
    extends: TableRowBase,
    computed: {
      actualValueRaw() {
        return this.round(this.getRatio(this.curMonth['num_errors'], this.curMonth['num_techs']), 2);
      },
      benchmarkValueRaw() {
        return this.round(this.getRatio(this.benchmarkMonth['num_errors'], this.benchmarkMonth['num_techs']), 2);
      },
      benchmarkVariance() {
        return this.round(this.actualValueRaw - this.benchmarkValueRaw, 2);
      },
      benchmarkValueDiff() {
        return (this.benchmarkValueRaw === '-') ? '-' : this.round(this.getValueDiff(this.actualValueRaw, this.benchmarkValueRaw), 2);
      },
      benchmarkYtdVariance() {
        return this.round(this.actualYtdRaw - this.benchmarkYtdRaw);
      },
      benchmarkYtdValueDiff() {
        return this.benchmarkYtdRaw === 0 ? '-' : this.round(this.getValueDiff(this.actualYtdRaw, this.benchmarkYtdRaw));
      },
      previousValueRaw() {
        return this.round(this.getRatio(this.prevYearMonth['num_errors'], this.prevYearMonth['num_techs']), 2);
      },
      previousYearValueDiff() {
        return this.prevYearNull ? 'N/A' : this.round(this.getValueDiff(this.actualValueRaw, this.previousValueRaw), 2);
      },
      previousYearVariance() {
        return (this.actualValue === '-') ? 0 : this.round(this.actualValueRaw - this.previousValueRaw, 2);
      },
      previousYtdVariance() {
        return this.round(this.actualYtdRaw - this.previousYtdRaw, 2);
      },
      previousYtdValueDiff() {
        return this.prevYearNull ? 'N/A' : this.round(this.getValueDiff(this.actualYtdRaw, this.previousYtdRaw));
      },

    },
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        const errors = this.getYtdByField(yearObj, 'num_errors', throughMonth);
        const techs = this.getYtdByField(yearObj, 'num_techs', throughMonth);
        return this.round(this.getRatio(errors, techs), 2);
      },
    },
  };
</script>
